var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 1.66675C1.04175 1.32157 1.32157 1.04175 1.66675 1.04175H4.16541C4.51059 1.04175 4.79041 1.32157 4.79041 1.66675V4.16541C4.79041 4.51059 4.51059 4.79041 4.16541 4.79041H1.66675C1.32157 4.79041 1.04175 4.51059 1.04175 4.16541V1.66675ZM2.29175 2.29175V3.54041H3.54041V2.29175H2.29175Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54053 2.91756C3.54053 2.57238 3.82035 2.29256 4.16553 2.29256H15.8324C16.1775 2.29256 16.4574 2.57238 16.4574 2.91756C16.4574 3.26274 16.1775 3.54256 15.8324 3.54256H4.16553C3.82035 3.54256 3.54053 3.26274 3.54053 2.91756Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91675 3.54053C3.26193 3.54053 3.54175 3.82035 3.54175 4.16553V15.8338C3.54175 16.179 3.26193 16.4588 2.91675 16.4588C2.57157 16.4588 2.29175 16.179 2.29175 15.8338V4.16553C2.29175 3.82035 2.57157 3.54053 2.91675 3.54053Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0816 3.54175C17.4268 3.54175 17.7066 3.82157 17.7066 4.16675V15.8351C17.7066 16.1802 17.4268 16.4601 17.0816 16.4601C16.7364 16.4601 16.4566 16.1802 16.4566 15.8351V4.16675C16.4566 3.82157 16.7364 3.54175 17.0816 3.54175Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54053 17.0842C3.54053 16.7391 3.82035 16.4592 4.16553 16.4592H15.8324C16.1775 16.4592 16.4574 16.7391 16.4574 17.0842C16.4574 17.4294 16.1775 17.7092 15.8324 17.7092H4.16553C3.82035 17.7092 3.54053 17.4294 3.54053 17.0842Z",
    fill: "#656579"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 15.8334C1.04175 15.4882 1.32157 15.2084 1.66675 15.2084H4.16541C4.51059 15.2084 4.79041 15.4882 4.79041 15.8334V18.3321C4.79041 18.6773 4.51059 18.9571 4.16541 18.9571H1.66675C1.32157 18.9571 1.04175 18.6773 1.04175 18.3321V15.8334ZM2.29175 16.4584V17.7071H3.54041V16.4584H2.29175Z",
    fill: "#656579"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2076 1.66838C15.2076 1.3232 15.4874 1.04338 15.8326 1.04338H18.3313C18.6764 1.04338 18.9563 1.3232 18.9563 1.66838V4.16704C18.9563 4.51222 18.6764 4.79204 18.3313 4.79204H15.8326C15.4874 4.79204 15.2076 4.51222 15.2076 4.16704V1.66838ZM16.4576 2.29338V3.54204H17.7063V2.29338H16.4576Z",
    fill: "#656579"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2076 15.835C15.2076 15.4899 15.4874 15.21 15.8326 15.21H18.3313C18.6764 15.21 18.9563 15.4899 18.9563 15.835V18.3337C18.9563 18.6789 18.6764 18.9587 18.3313 18.9587H15.8326C15.4874 18.9587 15.2076 18.6789 15.2076 18.3337V15.835ZM16.4576 16.46V17.7087H17.7063V16.46H16.4576Z",
    fill: "#656579"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22196 6.22644C6.40267 6.04572 6.6752 5.99324 6.9101 6.09391L12.7435 8.59391C12.982 8.69613 13.1325 8.93511 13.1217 9.19438C13.1109 9.45366 12.941 9.67929 12.6948 9.76132L10.4928 10.4951L9.75676 12.6996C9.6746 12.9457 9.44896 13.1155 9.18975 13.1262C8.93054 13.1369 8.69166 12.9864 8.58946 12.7479L6.08944 6.91458C5.98876 6.67968 6.04125 6.40715 6.22196 6.22644ZM7.85387 7.85834L9.09131 10.7457L9.40605 9.80294C9.46833 9.61642 9.61475 9.47009 9.80131 9.40792L10.7399 9.09518L7.85387 7.85834Z",
    fill: "#656579"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55747 9.55962C9.80163 9.31562 10.1974 9.31576 10.4414 9.55992L12.9397 12.0599C13.1837 12.3041 13.1835 12.6998 12.9394 12.9438C12.6952 13.1878 12.2995 13.1877 12.0555 12.9435L9.55718 10.4435C9.31318 10.1993 9.31331 9.80361 9.55747 9.55962Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconselect);
export default __webpack_public_path__ + "static/media/iconselect.db618e5e4a5779f495842027fe11f5b9.svg";
export { ForwardRef as ReactComponent };